import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIButton from 'UIComponents/button/UIButton';
import { GreyContainer, LargeWrapper, PopoverHeader } from './SharedStyleComponents';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentAssistantError = ({
  body,
  label,
  onCancel,
  onTryAgain
}) => {
  return /*#__PURE__*/_jsxs(LargeWrapper, {
    "data-test-id": "error-screen",
    children: [/*#__PURE__*/_jsx(PopoverHeader, {
      label: label,
      body: body,
      onCancel: onCancel
    }), /*#__PURE__*/_jsx(UIIllustration, {
      height: "70px",
      className: "m-all-2",
      name: "errors/general"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contentAssistantError.heading"
      })
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contentAssistantError.body"
      })
    }), /*#__PURE__*/_jsx(GreyContainer, {
      hideNavigation: true,
      children: /*#__PURE__*/_jsx(UIButton, {
        size: "small",
        use: "tertiary",
        onClick: onTryAgain,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentAssistantError.tryAgain"
        })
      })
    })]
  });
};
export default ContentAssistantError;